import { useCallback, useEffect } from "react";
import { useAudioPlayback } from "@/common/hooks/useAudioPlayback.ts";
import useCurrentExplorerItem from "@/common/hooks/useCurrentExplorerItem.ts";
import useAudioEditorPeaksInstance from "@/common/hooks/useAudioEditorPeaksInstance.ts";

function useAudioEnded() {
  const explorerItem = useCurrentExplorerItem()
  const [peaksInstance] = useAudioEditorPeaksInstance()
  const { playNextTrack } = useAudioPlayback()

  const handleAudioEnded = useCallback(() => {
    if (!explorerItem) {
      console.log('Warning: explorerItem is not defined')
      return;
    }
    // console.log('handleAudioEnded')
    playNextTrack(explorerItem)
  }, [
    explorerItem,
    playNextTrack
  ])

  useEffect(() => {
    if (!peaksInstance || !explorerItem) {
      return
    }

    peaksInstance?.on("player.ended", handleAudioEnded)

    return () => {
      peaksInstance?.off("player.ended", handleAudioEnded)
    }
  }, [
    explorerItem,
    peaksInstance,
    playNextTrack,
    handleAudioEnded
  ])
}

export default useAudioEnded;
